import { forwardRef, type Ref, type SVGProps } from "react";
const IconSparkleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12 22a2 2 0 0 1-2-2 5.963 5.963 0 0 0-5.957-5.957 2 2 0 1 1-.043-4 5.973 5.973 0 0 0 6-5.957A2.02 2.02 0 0 1 12 2a2 2 0 0 1 2 2 5.98 5.98 0 0 0 5.957 6.043H20a2 2 0 0 1 0 4A5.973 5.973 0 0 0 14 20a2 2 0 0 1-2 2m0-17.914a7.965 7.965 0 0 1-7.957 7.957A7.965 7.965 0 0 1 12 20a7.965 7.965 0 0 1 7.957-7.957A7.965 7.965 0 0 1 12 4.086M20 30a2 2 0 0 1-2-2 1.883 1.883 0 0 0-1.881-1.881H16a2 2 0 0 1 0-4h.119A1.883 1.883 0 0 0 18 20.238V20a2 2 0 0 1 4 0v.238a1.883 1.883 0 0 0 1.881 1.881H24a2 2 0 0 1 0 4h-.119A1.883 1.883 0 0 0 22 28a2 2 0 0 1-2 2m-4-5.881h.119A3.885 3.885 0 0 1 20 28a3.885 3.885 0 0 1 3.881-3.881A3.885 3.885 0 0 1 20 20.238a3.885 3.885 0 0 1-3.881 3.881ZM26.5 20a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5m0-5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5" />
  </svg>
);
const ForwardRef = forwardRef(IconSparkleOutlineSVG);
ForwardRef.displayName = "IconSparkleOutline";
export { ForwardRef as IconSparkleOutline };
